import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import Clickable from 'components/Common/Clickable'
import LineExchangeAltIcon from 'components/Luxkit/Icons/line/LineExchangeAltIcon'

const Root = styled(Clickable)`
  border-top: 1px solid ${props => props.theme.palette.neutral.five};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.five};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${rem(48)};
  height: ${rem(48)};
`

interface Props {
  onClick: () => void;
}

const ExchangeButton = (props: Props) => {
  const { onClick } = props

  return (
    <Root onClick={onClick} tabIndex={-1}>
      <LineExchangeAltIcon size={24} />
    </Root>
  )
}

export default ExchangeButton
